<template>
  <v-card :max-width="maxWidth">
    <v-form
      @submit.prevent="submitForm"
      ref="form"
      v-model="valid"
      class="pa-4"
    >
      <h3 class="mb-4 text-center font-weight-regular">
        {{ title }}
      </h3>
      <v-alert
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1 mb-5"
      >
        {{ alertValidate }}
      </v-alert>
      <v-text-field
        name="name"
        v-model="name"
        :label="this.$tc('attributes.labelTitle')"
        outlined
        :rules="rules"
        dense
        class="ma-0"
      />
      <v-text-field
        name="description"
        v-model="description"
        :label="this.$tc('attributes.labelDescription')"
        outlined
        :rules="rules"
        dense
        class="ma-0"
      />
      <v-autocomplete
        name="type"
        dense
        :rules="rules"
        outlined
        v-model="type"
        :label="this.$tc('attributes.labelType')"
        :items="typeArray"
        :item-text="truncateText"
        item-value="id"
        class="ma-0"
        :menu-props="{ auto: false, overflowY: true }"
        @change="changeType(type)"
      />
      <v-text-field
        name="values"
        v-model="values"
        :label="this.$tc('attributes.labelLista')"
        outlined
        :rules="dynamicRules"
        dense
        class="ma-0"
        :disabled="dynamicDisabled"
      />
      <div class="d-flex justify-space-between pt-4">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
  </v-card>
</template>

<script>
import attributes from "../../../../store/atributos/attributes";
export default {
  data() {
    return {
      form: {},
      alertValidate: "",
      valid: false,
      name: "",
      description: "",
      type: "",
      values: "",
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      error: false,
      itemOld: null,
      typeArray: ["Entero", "Cadena", "Lista"],
    };
  },
  props: {
    maxWidth: String,
    mode: String,
    title: String,
  },
  computed: {
    dataEdit() {
      return attributes.state.edit || null;
    },
    dynamicDisabled() {
      switch (this.type) {
        case "Entero":
        case "Cadena":
          return true;
        case "Lista":
          return false;
        default:
          return true;
      }
    },
    dynamicRules() {
      switch (this.type) {
        case "Lista":
          return [
            (value) => !!value || this.$tc("editRegistrations.required"),
            (value) => this.isValidLValue(value),
          ];
      }
    },
  },
  methods: {
    changeType(type) {
      this.type = type;
    },
    isValidLValue(value) {
      const regex = /^([a-zA-Z0-9]+)(,[a-zA-Z0-9]+)*$/;
      if (regex.test(value)) {
        return true;
      } else {
        return this.$tc("attributes.invalidValue");
      }
    },
    truncateText(item) {
      const maxLength = 65;
      if (item.codeDescription.length > maxLength) {
        return item.codeDescription.substring(0, maxLength) + "...";
      }
      return item.codeDescription;
    },
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();
      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
  },
  mounted() {
    if (attributes.state.modeForm == "Editar atributo") {
      this.name = attributes.state.edit.name;
      this.description = attributes.state.edit.description;
      this.type = attributes.state.edit.type;

      if (attributes.state.edit.hasOwnProperty("values")) {
        this.values = attributes.state.edit.values;
      }
    }
  },
};
</script>

<style>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
